import { gql } from '@provision/graphql-client';

export const ACTIVITY_FEED_FRAGMENT = gql`
  fragment ActivityFeedFields on ActivityFeed {
    id
    partnerId
    actor {
      name
    }
    entity
    activityType
    changes {
      name
      previousValue
      value
      customType
      icon
      field
      skip
    }
    timestamp
    actorUid
  }
`;
